import { createGetEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type GetInvitationLinkRequest = {
	userId: number;
	shardName?: string;
};

export type GetInvitationLinkResponse = {
	link: string;
};

export const getInvitationLink = createGetEndpoint<GetInvitationLinkRequest, GetInvitationLinkResponse>(
	(request) => `/api/v3/core/users/${request?.userId}/links/invitation`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
